// src/pages/B2B/event-reports/pdf/warm/sections/WarmEngagementBox.tsx
import React from 'react';
import { EngagementChart } from '../charts/EngagementChart';
import type { EventReportPayload } from '../../../types';

interface Props {
  payload: EventReportPayload;
  timezone: string;
  windowStartUtcIso: string;
  windowMinutes: number;
}

function fmt(n: number): string { return n.toLocaleString(); }

export function WarmEngagementBox(props: Props): React.ReactElement {
  const { payload, timezone, windowStartUtcIso, windowMinutes } = props;
  const peak = payload.active_users_samples.reduce((m, s) => s.count > m ? s.count : m, 0);
  const goings = payload.going_clicks_at_utc.length;
  return (
    <div className="box">
      <h2>Live engagement timeline</h2>
      <p className="box-sub">Active users, going clicks, and broadcasts in the window</p>
      <EngagementChart
        samples={payload.active_users_samples}
        goingClickIsoTimes={payload.going_clicks_at_utc}
        notifEvents={[]}
        timezone={timezone}
        windowStartUtcIso={windowStartUtcIso}
        windowMinutes={windowMinutes}
        width={760}
        height={260}
        showGoingBars={true}
        highlightTopPeaks={2}
      />
      <div className="box-grid" style={{ marginTop: 22 }}>
        <div className="stat"><div className="lbl">Peak active users</div><div className="val">{fmt(peak)}</div></div>
        <div className="stat"><div className="lbl">Going clicks</div><div className="val">{fmt(goings)}</div></div>
      </div>
    </div>
  );
}
